import { useNavigate } from "react-router-dom";

import { Button, Size, Variant } from "../../components/Buttons";

import notFoundIcon from "../../assets/icons/not_found.png";

import { View } from "./styles";

export const Error404 = () => {
  const navigate = useNavigate();

  return (
    <View>
      <img
        src={ notFoundIcon }
        alt="404: Not Found"
      />

      <strong>Página não encontrada!</strong>

      <Button
        onClick={() => navigate("/", { replace: true })}
        $color="text"
        $size={ Size.LARGE }
        $variant={ Variant.OUTLINED }
      >
        Voltar para início
      </Button>
    </View>
  )
};
